"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EuraSelect = void 0;
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const Icons_1 = require("./Icons");
require("../styles/eura-select.css");
const EuraSelect = (props) => {
    const { className } = props, other = __rest(props, ["className"]);
    const classConstruct = ['eura-select', className !== null && className !== void 0 ? className : ''];
    return (react_1.default.createElement(antd_1.Select, Object.assign({}, other, { listHeight: 224, virtual: false, suffixIcon: react_1.default.createElement(Icons_1.DropdownArrowIcon, { width: '0.933em', height: '0.933em' }), className: classConstruct.join(' ') })));
};
exports.EuraSelect = EuraSelect;
const EuraSelectOption = (props) => {
    return react_1.default.createElement(antd_1.Select.Option, Object.assign({}, props));
};
exports.EuraSelect.Option = EuraSelectOption;
